"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var authentication_service_1 = require("./authentication.service");
var router_1 = require("@angular/router");
require("rxjs/add/operator/catch");
require("rxjs/add/observable/throw");
var Subject_1 = require("rxjs/Subject");
require("rxjs/add/operator/switchMap");
require("rxjs/add/observable/empty");
var AuthInterceptor = /** @class */ (function () {
    function AuthInterceptor(injector, router) {
        this.injector = injector;
        this.router = router;
        this.refreshTokenInProgress = false;
        this.tokenRefreshedSource = new Subject_1.Subject();
        this.onTokenRefreshed = this.tokenRefreshedSource.asObservable();
    }
    AuthInterceptor.prototype.intercept = function (request, next) {
        var _this = this;
        this.authService = this.injector.get(authentication_service_1.AuthenticationService);
        // Handle request
        request = this.addAuthHeader(request);
        // Handle response
        return next.handle(request).catch(function (error) {
            if (error.status === 401 && !request.url.endsWith('/api/login') && !request.url.endsWith('/api/user/renew')) {
                return _this.refreshToken()
                    .switchMap(function () {
                    request = _this.addAuthHeader(request);
                    return next.handle(request);
                })
                    .catch(function () {
                    _this.authService.logout();
                    return Observable_1.Observable.empty();
                });
            }
            else if (error.status === 401 || error.status === 403) {
                _this.authService.logout();
                _this.router.navigateByUrl('/login', { replaceUrl: true });
            }
            return Observable_1.Observable.throw(error);
        });
    };
    AuthInterceptor.prototype.addAuthHeader = function (request) {
        var token = this.authService.token;
        if (request.url.endsWith('/api/user/renew')) {
            token = this.authService.renewToken;
        }
        if (token) {
            return request.clone({
                setHeaders: {
                    'Authorization': "Bearer " + token
                }
            });
        }
        return request;
    };
    AuthInterceptor.prototype.refreshToken = function () {
        var _this = this;
        if (this.refreshTokenInProgress) {
            return new Observable_1.Observable(function (observer) {
                _this.onTokenRefreshed.subscribe(function () {
                    observer.next();
                    observer.complete();
                });
            });
        }
        else {
            this.refreshTokenInProgress = true;
            return this.authService.refreshToken()
                .do(function () {
                _this.refreshTokenInProgress = false;
                _this.tokenRefreshedSource.next();
            }).catch(function () {
                return Observable_1.Observable.empty();
            });
        }
    };
    AuthInterceptor = tslib_1.__decorate([
        core_1.Injectable(),
        tslib_1.__metadata("design:paramtypes", [core_1.Injector, router_1.Router])
    ], AuthInterceptor);
    return AuthInterceptor;
}());
exports.AuthInterceptor = AuthInterceptor;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXV0aGVudGljYXRpb24uaW50ZXJjZXB0b3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJhdXRoZW50aWNhdGlvbi5pbnRlcmNlcHRvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxzQ0FBcUQ7QUFFckQsOENBQTZDO0FBQzdDLG1FQUFpRTtBQUNqRSwwQ0FBeUM7QUFFekMsbUNBQWlDO0FBQ2pDLHFDQUFtQztBQUNuQyx3Q0FBdUM7QUFDdkMsdUNBQXFDO0FBQ3JDLHFDQUFtQztBQUduQztJQU9JLHlCQUFvQixRQUFrQixFQUFVLE1BQWM7UUFBMUMsYUFBUSxHQUFSLFFBQVEsQ0FBVTtRQUFVLFdBQU0sR0FBTixNQUFNLENBQVE7UUFOdEQsMkJBQXNCLEdBQUcsS0FBSyxDQUFDO1FBRS9CLHlCQUFvQixHQUFHLElBQUksaUJBQU8sRUFBRSxDQUFDO1FBQ3JDLHFCQUFnQixHQUFHLElBQUksQ0FBQyxvQkFBb0IsQ0FBQyxZQUFZLEVBQUUsQ0FBQztJQUlwRSxDQUFDO0lBRUQsbUNBQVMsR0FBVCxVQUFVLE9BQXlCLEVBQUUsSUFBaUI7UUFBdEQsaUJBMEJDO1FBekJHLElBQUksQ0FBQyxXQUFXLEdBQUcsSUFBSSxDQUFDLFFBQVEsQ0FBQyxHQUFHLENBQUMsOENBQXFCLENBQUMsQ0FBQztRQUU1RCxpQkFBaUI7UUFDakIsT0FBTyxHQUFHLElBQUksQ0FBQyxhQUFhLENBQUMsT0FBTyxDQUFDLENBQUM7UUFFdEMsa0JBQWtCO1FBQ2xCLE9BQU8sSUFBSSxDQUFDLE1BQU0sQ0FBQyxPQUFPLENBQUMsQ0FBQyxLQUFLLENBQUMsVUFBQSxLQUFLO1lBRW5DLElBQUksS0FBSyxDQUFDLE1BQU0sS0FBSyxHQUFHLElBQUksQ0FBQyxPQUFPLENBQUMsR0FBRyxDQUFDLFFBQVEsQ0FBQyxZQUFZLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsUUFBUSxDQUFDLGlCQUFpQixDQUFDLEVBQUU7Z0JBQ3pHLE9BQU8sS0FBSSxDQUFDLFlBQVksRUFBRTtxQkFDckIsU0FBUyxDQUFDO29CQUNQLE9BQU8sR0FBRyxLQUFJLENBQUMsYUFBYSxDQUFDLE9BQU8sQ0FBQyxDQUFDO29CQUN0QyxPQUFPLElBQUksQ0FBQyxNQUFNLENBQUMsT0FBTyxDQUFDLENBQUM7Z0JBQ2hDLENBQUMsQ0FBQztxQkFDRCxLQUFLLENBQUM7b0JBQ0gsS0FBSSxDQUFDLFdBQVcsQ0FBQyxNQUFNLEVBQUUsQ0FBQztvQkFDMUIsT0FBTyx1QkFBVSxDQUFDLEtBQUssRUFBRSxDQUFDO2dCQUM5QixDQUFDLENBQUMsQ0FBQzthQUNWO2lCQUFNLElBQUksS0FBSyxDQUFDLE1BQU0sS0FBSyxHQUFHLElBQUksS0FBSyxDQUFDLE1BQU0sS0FBSyxHQUFHLEVBQUU7Z0JBQ3JELEtBQUksQ0FBQyxXQUFXLENBQUMsTUFBTSxFQUFFLENBQUM7Z0JBQzFCLEtBQUksQ0FBQyxNQUFNLENBQUMsYUFBYSxDQUFDLFFBQVEsRUFBRSxFQUFDLFVBQVUsRUFBRSxJQUFJLEVBQUMsQ0FBQyxDQUFDO2FBQzNEO1lBRUQsT0FBTyx1QkFBVSxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsQ0FBQztRQUNuQyxDQUFDLENBQUMsQ0FBQztJQUNQLENBQUM7SUFFTyx1Q0FBYSxHQUFyQixVQUFzQixPQUF5QjtRQUMzQyxJQUFJLEtBQUssR0FBRyxJQUFJLENBQUMsV0FBVyxDQUFDLEtBQUssQ0FBQztRQUVuQyxJQUFJLE9BQU8sQ0FBQyxHQUFHLENBQUMsUUFBUSxDQUFDLGlCQUFpQixDQUFDLEVBQUU7WUFDekMsS0FBSyxHQUFHLElBQUksQ0FBQyxXQUFXLENBQUMsVUFBVSxDQUFDO1NBQ3ZDO1FBQ0QsSUFBSSxLQUFLLEVBQUU7WUFDUCxPQUFPLE9BQU8sQ0FBQyxLQUFLLENBQUM7Z0JBQ2pCLFVBQVUsRUFBRTtvQkFDUixlQUFlLEVBQUUsWUFBVSxLQUFPO2lCQUNyQzthQUNKLENBQUMsQ0FBQztTQUNOO1FBQ0QsT0FBTyxPQUFPLENBQUM7SUFDbkIsQ0FBQztJQUVPLHNDQUFZLEdBQXBCO1FBQUEsaUJBbUJDO1FBbEJHLElBQUksSUFBSSxDQUFDLHNCQUFzQixFQUFFO1lBQzdCLE9BQU8sSUFBSSx1QkFBVSxDQUFDLFVBQUEsUUFBUTtnQkFDMUIsS0FBSSxDQUFDLGdCQUFnQixDQUFDLFNBQVMsQ0FBQztvQkFDNUIsUUFBUSxDQUFDLElBQUksRUFBRSxDQUFDO29CQUNoQixRQUFRLENBQUMsUUFBUSxFQUFFLENBQUM7Z0JBQ3hCLENBQUMsQ0FBQyxDQUFDO1lBQ1AsQ0FBQyxDQUFDLENBQUM7U0FDTjthQUFNO1lBQ0gsSUFBSSxDQUFDLHNCQUFzQixHQUFHLElBQUksQ0FBQztZQUVuQyxPQUFPLElBQUksQ0FBQyxXQUFXLENBQUMsWUFBWSxFQUFFO2lCQUNqQyxFQUFFLENBQUM7Z0JBQ0EsS0FBSSxDQUFDLHNCQUFzQixHQUFHLEtBQUssQ0FBQztnQkFDcEMsS0FBSSxDQUFDLG9CQUFvQixDQUFDLElBQUksRUFBRSxDQUFDO1lBQ3JDLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQztnQkFDTCxPQUFPLHVCQUFVLENBQUMsS0FBSyxFQUFFLENBQUM7WUFDOUIsQ0FBQyxDQUFDLENBQUM7U0FDVjtJQUNMLENBQUM7SUF6RVEsZUFBZTtRQUQzQixpQkFBVSxFQUFFO2lEQVFxQixlQUFRLEVBQWtCLGVBQU07T0FQckQsZUFBZSxDQTBFM0I7SUFBRCxzQkFBQztDQUFBLEFBMUVELElBMEVDO0FBMUVZLDBDQUFlIn0=


//////////////////
// WEBPACK FOOTER
// ./src/app/core/authentication/authentication.interceptor.ts
// module id = 617
// module chunks = 0